import PopupForm from "app/common/Component/Popup/PopupForm";
import { observer } from "mobx-react";
import React, { memo } from "react";
import { Grid, useMediaQuery, useTheme } from "@material-ui/core";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import CommonButton from "app/common/Component/Button/CommonButton";
import { Block, Save } from "@material-ui/icons";
import {
  RELATIONSHIP_TYPES,
} from "app/common/LocalConst";
import GlobitsSelectInput from "app/common/form/GlobitsSelectInput";
import { pagingPatient } from "app/services/PatientService";
import { hideMiddleDigits } from "app/common/LocalFunction";
import { useStore } from "app/stores";
import { filterOptionsPatient } from "utils";
import * as Yup from "yup";
const PopupRalationShip = ({ open, handleClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const { handleCreateRelationship, initialPatient } =
    useStore().patientManagementStore.patientGeneralStore;
  return (
    <PopupForm
      open={open}
      handleClose={handleClose}
      size="sm"
      title={"Cập nhật mối quan hệ khách hàng"}
      formik={{
        initialValues: {
          patient: initialPatient?.patientInfo || null,
          relatedPatient: null,
          relationship: null,
        },
        validationSchema: Yup.object().shape({
          relatedPatient: Yup.object()
            .nullable()
            .required("Vui lòng chọn người đi cùng"),
          relationship: Yup.string()
            .nullable()
            .required("Vui lòng chọn mối quan hệ"),
        }),
        onSubmit: async (values, { setSubmitting }) => {
          const relationship = {
            patient: values?.patient,
            relatedPatient: values?.relatedPatient,
            relationship: values?.relationship,
          };
          await handleCreateRelationship(relationship);
          setSubmitting(false);
        },
        enableReinitialize: true,
      }}
      action={({ isSubmitting, values }) => {
        return (
          <div className="flex-center gap-1">
            <CommonButton type="submit">
              {!isMobile && <Save className="mr-2 " />}
              Lưu
            </CommonButton>

            <CommonButton className="btn-gray" onClick={handleClose}>
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ values }) => (
        <>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <GlobitsPagingAutocomplete
                label={"Người đến chính"}
                name="patient"
                api={pagingPatient}
                getOptionLabel={(option) => option?.displayName || ""}
                disabled
              />
            </Grid>
            <Grid item xs={12}>
              <GlobitsSelectInput
                label="Mối quan hệ"
                name="relationship"
                options={RELATIONSHIP_TYPES}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <GlobitsPagingAutocomplete
                label={"Người đi cùng"}
                name="relatedPatient"
                api={pagingPatient}
                getOptionLabel={(option) => {
                  let render = option?.displayName || "";
                  if (option?.phoneNumber) {
                    render += ` - ${hideMiddleDigits(option?.phoneNumber)}`;
                  }
                  return render;
                }}
                filterOptions={filterOptionsPatient}
                required
              />
            </Grid>
          </Grid>
        </>
      )}
    </PopupForm>
  );
};

export default memo(observer(PopupRalationShip));
